module.exports = __webpack_public_path__ + "static/media/square-full.c6fd7e8f.svg";